/* ============================================================
   DIVANOSO — Rata dinamica nel drawer iCart — v2.2
   Box verde tenue sotto il Totale, con ICONA carta di credito
   (la stessa del vecchio bullet trust) + testo:
   "Paga anche da €X/mese in 12 rate"  (X = totale / 12)
   NIENTE claim su interessi: compliance.
   ------------------------------------------------------------
   INSTALLAZIONE: sostituisce INTEGRALMENTE il contenuto di
   Assets/rata-drawer.js. La riga in theme.liquid resta quella:
   <script src="{{ 'rata-drawer.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  var TOTAL_SELECTOR = '.icart .icart-final-total';
  var LINE_CLASS = 'dv-rata';
  var N_RATE = 12;

  /* Parser robusto: il separatore DECIMALE e' l'ultimo che
     compare, tranne quando e' seguito da esattamente 3 cifre
     finali (allora e' un separatore delle migliaia).
     "1.690,00" -> 1690 | "1,690.00" -> 1690
     "2470.00"  -> 2470 | "1.690"    -> 1690 | "140,83" -> 140.83 */
  function parseEuro(txt) {
    var m = txt.match(/€\s*([\d.,]+)/g);
    if (!m || !m.length) return NaN;
    var s = m[m.length - 1].replace(/[^\d.,]/g, '');

    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    var sepPos = Math.max(lastDot, lastComma);

    if (sepPos === -1) return parseFloat(s); /* nessun separatore */

    var decimals = s.length - sepPos - 1;
    var intPart, decPart;
    if (decimals === 3) {
      /* ultimo separatore = migliaia: niente decimali */
      intPart = s.replace(/[.,]/g, '');
      decPart = '';
    } else {
      intPart = s.slice(0, sepPos).replace(/[.,]/g, '');
      decPart = s.slice(sepPos + 1);
    }
    return parseFloat(intPart + (decPart ? '.' + decPart : ''));
  }

  function formatEuro(n) {
    return '\u20AC' + n.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function visibleTotal() {
    var found = null;
    document.querySelectorAll(TOTAL_SELECTOR).forEach(function (el) {
      if (el.offsetParent !== null) found = el; /* solo elementi visibili */
    });
    return found;
  }

  function render() {
    var totalEl = visibleTotal();
    if (!totalEl) return;

    var total = parseEuro(totalEl.textContent || '');
    if (!(total > 0)) return;

    var rata = formatEuro(total / N_RATE);
    var html =
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" ' +
      'stroke="#00875F" stroke-width="2" stroke-linecap="round" ' +
      'stroke-linejoin="round" style="flex:0 0 auto;">' +
      '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>' +
      '<line x1="1" y1="10" x2="23" y2="10"></line></svg>' +
      '<span>Paga anche da <strong style="color:#1a1a1a;">' +
      rata + '/mese</strong> in 12 rate</span>';

    var line = totalEl.parentNode.querySelector('.' + LINE_CLASS);
    if (!line) {
      line = document.createElement('div');
      line.className = LINE_CLASS;
      line.style.cssText =
        'display:flex;align-items:center;gap:8px;' +
        'font-family:Arial,Helvetica,sans-serif;' +
        'font-size:15px;line-height:1.4;color:#333333;' +
        'background:#F2FAF7;border-radius:8px;' +
        'padding:8px 12px;margin:6px 0 2px;text-align:left;';
      totalEl.parentNode.insertBefore(line, totalEl.nextSibling);
    }
    if (line.innerHTML !== html) line.innerHTML = html;
  }

  var t = null;
  var observer = new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(render, 150);
  });

  function start() {
    render();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();